<template>
  <div class="flex-1 overflow-auto p-4">
    <div class="button--fixed-top gap-2">
      <woot-button
        v-if="isAdmin"
        color-scheme="secondary"
        icon="arrow-download"
        @click="openExportConversationsModal"
      >
        {{ $t('EXPORT_CONVERSATIONS.BUTTON_LABEL') }}
      </woot-button>
      <woot-button
        color-scheme="success"
        icon="arrow-download"
        @click="openDownloadModal"
      >
        {{ $t('REPORT.DOWNLOAD_AGENT_REPORTS') }}
      </woot-button>
    </div>
    <report-filter-selector
      :show-agents-filter="false"
      :show-group-by-filter="true"
      @filter-change="onFilterChange"
    />
    <report-container :group-by="groupBy" />
    <woot-modal :show.sync="downloadModalOpen" :on-close="onCloseDownloadModal">
      <download-report-modal v-if="downloadModalOpen" :title="$t('REPORT.DOWNLOAD_AGENT_REPORTS')" :show="downloadModalOpen" :on-close="onCloseDownloadModal" :on-choose="downloadReports" />
    </woot-modal>
    <export-conversations-modal
      v-if="isAdmin && showExportConversationsModal"
      :show.sync="showExportConversationsModal"
      :on-close="closeExportConversationsModal"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import fromUnixTime from 'date-fns/fromUnixTime';
import format from 'date-fns/format';
import ReportFilterSelector from './components/FilterSelector';
import { GROUP_BY_FILTER } from './constants';
import reportMixin from 'dashboard/mixins/reportMixin';
import alertMixin from 'shared/mixins/alertMixin';
import isAdminMixin from 'dashboard/mixins/isAdmin';
import { REPORTS_EVENTS } from '../../../../helper/AnalyticsHelper/events';
import ReportContainer from './ReportContainer.vue';
import DownloadReportModal from './components/DownloadReportModal.vue';
import ExportConversationsModal from './components/ExportConversationsModal.vue';

const REPORTS_KEYS = {
  CONVERSATIONS: 'conversations_count',
  INCOMING_MESSAGES: 'incoming_messages_count',
  OUTGOING_MESSAGES: 'outgoing_messages_count',
  FIRST_RESPONSE_TIME: 'avg_first_response_time',
  RESOLUTION_TIME: 'avg_resolution_time',
  RESOLUTION_COUNT: 'resolutions_count',
  REPLY_TIME: 'reply_time',
};

export default {
  name: 'ConversationReports',
  components: {
    ReportFilterSelector,
    ReportContainer,
    DownloadReportModal,
    ExportConversationsModal,
  },
  mixins: [reportMixin, alertMixin, isAdminMixin],
  data() {
    return {
      from: 0,
      to: 0,
      groupBy: GROUP_BY_FILTER[1],
      businessHours: false,
      showExportConversationsModal: false,

      downloadModalOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      accountSummary: 'getAccountSummary',
      accountReport: 'getAccountReports',
    }),
  },
  methods: {
    fetchAllData() {
      this.fetchAccountSummary();
      this.fetchChartData();
    },
    fetchAccountSummary() {
      try {
        this.$store.dispatch('fetchAccountSummary', this.getRequestPayload());
      } catch {
        this.showAlert(this.$t('REPORT.SUMMARY_FETCHING_FAILED'));
      }
    },
    fetchChartData() {
      [
        'CONVERSATIONS',
        'INCOMING_MESSAGES',
        'OUTGOING_MESSAGES',
        'FIRST_RESPONSE_TIME',
        'RESOLUTION_TIME',
        'RESOLUTION_COUNT',
        'REPLY_TIME',
      ].forEach(async key => {
        try {
          await this.$store.dispatch('fetchAccountReport', {
            metric: REPORTS_KEYS[key],
            ...this.getRequestPayload(),
          });
        } catch {
          this.showAlert(this.$t('REPORT.DATA_FETCHING_FAILED'));
        }
      });
    },
    getRequestPayload() {
      const { from, to, groupBy, businessHours } = this;

      return {
        from,
        to,
        groupBy: groupBy?.period,
        businessHours,
      };
    },
    openDownloadModal(){
      this.downloadModalOpen = true
    },
    onCloseDownloadModal(){
      this.downloadModalOpen = false
    },
    openExportConversationsModal() {
      this.showExportConversationsModal = true;
    },
    closeExportConversationsModal() {
      this.showExportConversationsModal = false;
    },
    downloadReports(fileType) {
      const { from, to } = this;
      const fileName = `agent-report-${format(
        fromUnixTime(to),
        'dd-MM-yyyy'
      )}.${fileType}`;
      this.$store.dispatch('downloadAgentReports', { from, to, fileName, fileType });
    },
    onFilterChange({ from, to, groupBy, businessHours }) {
      this.from = from;
      this.to = to;
      this.groupBy = groupBy;
      this.businessHours = businessHours;
      this.fetchAllData();

      this.$track(REPORTS_EVENTS.FILTER_REPORT, {
        filterValue: { from, to, groupBy, businessHours },
        reportType: 'conversations',
      });
    },
  },
};
</script>
